import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo_medium from '../assets/logo_medium_white.png';
import axiosInstance from '../utils/axios';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [ssoUrl, setSsoUrl] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, loading } = useSelector((state) => state.auth);

  // Fetch the SSO endpoint from the Django backend
  useEffect(() => {
    const fetchSSOUrl = async () => {
      try {
        const response = await axiosInstance.get(`/auth/sso/jumpcloud`);
        console.dir(response.data)
        setSsoUrl(response.data.sso_url);
      } catch (error) {
        console.error('Error fetching SSO URL:', error);
      }
    };

    fetchSSOUrl();
  }, []);

  // Standard username/password login
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(login({ username, password }));
    if (login.fulfilled.match(result)) {
      navigate('/home');
    }
  };

  // Handle JumpCloud SSO login
  const handleJumpCloudLogin = () => {
    if (ssoUrl) {
      window.location.href = ssoUrl;  // Redirect to JumpCloud SSO
    } else {
      console.error('SSO URL not available');
    }
  };
  
  return (
    <div className="login-container">
      <img src={logo_medium} alt="Logo" className="logo" />
      <h1>Login into your account</h1>
      {!ssoUrl && (

      <form className="login-form" onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={loading}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      )} 

      {/* JumpCloud SSO Login Option */}
      {ssoUrl && (
        <div className="sso-login">
          <button className='jumpcloudSSO' onClick={handleJumpCloudLogin} disabled={loading}>
            Login with JumpCloud
          </button>
        </div>
      )} 
    </div>
  );
};

export default Login;
